export default __webpack_public_path__ + "static/logo2-light-65ab0b49fbe9877a0203b2b48b5cf18e.svg";